import { computed } from '@preact/signals-react';

import buildClient from '@furality/boop-client/buildClient.js';
import { auth } from '@furality/frontend-stack';

export const BOOP_HOST =
  (import.meta.env['PUBLIC_BOOP_API_HOST'] as string | undefined) ?? 'https://boop.dev.fynn.ai';

const boop = computed(() =>
  buildClient({
    basePath: BOOP_HOST,
    auth: {
      bearer: auth.value.auth?.token,
    },
  }),
);

export default boop;
